document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const root = event.target.closest('[data-product-root]');
      const price = root?.querySelector('[data-product-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
